import { MODAL } from '../utils/constants.json';

const INITIAL_STATE = {
  viewdefaultModal: { content: '', visible: false, title: '' },
};

/**
 * Reducer - to update services state
 * @param {Object} state initial/default services state.
 * @param {Object} action to be performed
 * @return {Object} new services state
 */
export default function (state = INITIAL_STATE, action) {
  const { payload } = action;
  switch (action.type) {
    case MODAL.OPEN_DEFAULT_MODAL:
      return { ...state, viewdefaultModal: { visible: true, ...payload } };
    case MODAL.CLOSE_DEFAULT_MODAL:
      return { ...state, viewdefaultModal: { visible: false, ...payload } };
    case MODAL.CLEAR_MODAL:
      return { ...INITIAL_STATE };
    default:
      return { ...state };
  }
}
